import React from 'react'
import PageHeader from '../../Components/Instructor_Dashboard/PageHeader'
import { Row,Col } from 'antd'
import RangeDatePicker from '../../Components/RangeDatePicker'
import CommonTable from '../../Components/CommonTable'

const columns = [
    {
        title: '#',
        dataIndex: 'index',
        key: 'index',
        render: (text, record, index) => index + 1,  // Display the index (1-based index)
    },
    {
      title: 'Course Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name), 
    },
    {
      title: 'Instructor revenue',
      dataIndex: 'revenue',
      key: 'age',
      sorter: (a, b) => a.revenue.localeCompare(b.revenue), 
    },
]

const data = [
    {
      key: 1,
      name: 'John Brown',
      revenue:5968
    },
    {
      key: 2,
      name: 'Jim Green',
      revenue:9
    }
]

const Sales_Report = () => {
  return (
    <div className='sales_report_page'>
       <PageHeader title={'Sales report'}/>

       <div className='sales_report_page_div'>
          <h3>Sales report</h3>
          
          <div className='date_picker'>
             <RangeDatePicker />
          </div>

          <div>
              <CommonTable columns={columns} data={data}/>
          </div>
       </div>
    </div>
  )
}

export default Sales_Report
